/* hs-eslint ignored failing-rules */
/* eslint-disable conversations/no-dynamic-i18n */

'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import { isEmailCMF } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getPublishFailedErrorPath, getEmailClientName } from './operators/getPublishFailedErrorString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FailedToPublishMessageText = ({
  message,
  onRepublish,
  connectedAccounts,
  allowRetry = true
}) => /*#__PURE__*/_jsxs(Small, {
  use: "error",
  children: [/*#__PURE__*/_jsx(UIIcon, {
    name: "warning",
    className: "m-right-1"
  }), getPublishFailedErrorPath(message, {
    clientType: getEmailClientName(message, connectedAccounts),
    WhatsAppSizeLimits: 'https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media#supported-media-types'
  }), !isEmailCMF(message) && allowRetry && /*#__PURE__*/_jsx(UILink, {
    use: "danger",
    onClick: () => onRepublish(message),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      className: "m-left-1",
      message: 'conversations-inbox-message-history.status.publishing.RETRY'
    })
  })]
});
FailedToPublishMessageText.displayName = 'FailedToPublishMessageText';
FailedToPublishMessageText.propTypes = {
  allowRetry: PropTypes.bool,
  connectedAccounts: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  onRepublish: PropTypes.func.isRequired
};
export default FailedToPublishMessageText;